<div class="flex flex-row items-center">
  <div class="text-cafe text-base font-normal font-['Roboto'] tracking-tight mr-1">
    {{ 'components.LnProductFilterComponent.sortBy' | transloco }}<span class="font-medium"> {{ ('sortFilter.'+selectedFilter()) | transloco}}</span>
  </div>
  <div class="relative inline-block">
    <button
      (click)="ToggleMenu()"
      class="flex items-center fill-current justify-self-end hover:cursor-pointer sm:hover:bg-gray-200 aspect-square sm:hover:rounded-full">
      <div class="transform transition-transform duration-200" [ngClass]="{ 'rotate-180': showMenu() }">
        <ln-chevron-down-svg-icon [class]="'h-[12px] w-[24px]'" fillColor = "#372121"></ln-chevron-down-svg-icon>
      </div>
    </button>
    @if (showMenu()) {
      <div
        class="absolute left-full translate-x-[-100%] mt-1 bg-blanco shadow-lg transition-all duration-200 z-10 rounded-md text-base font-normal divide-y divide-gray-100 w-[168px]"
        lnClickOutSide
        (clickOutside)="CloseMenu()">
        <ul class="text-cafe py-2">
          @for (item of filterValues; track item) {
            <li class="py-2 hover:bg-gray-100 flex flex-col">
              <button class="cursor-pointer px-4 hover:scale-110 transition-transform duration-300" (click)="OnMenuItemSelect(item)">
                {{ ('sortFilter.'+item) | transloco }}
              </button>
              <div class="mx-2 mt-0.5 h-0 outline outline-[1px] outline-offset-[-0.50px] outline-zinc-200"></div>
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
